// Pure derivations for the athlete editor redesign — no I/O. Mirrors the
// column-backed measurable filter used by MeasurablesEditor and the verify
// summary shown in the identity bar. Tested in athleteEditorModel.test.js.

const humanize = s => (s ? String(s).replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : '');

// Gear fields are not catalog measurables but carry `_verified` columns and
// render in the Measurables card, so they count toward the verify summary.
export const GEAR_FIELD_KEYS = ['shoe_size', 'shoe_vendor', 'cleat_vendor', 'jersey_size', 'hand_preference', 'foot_preference'];

const hasValue = v => v !== null && v !== undefined && v !== '';

// Only keys that are real ORM columns on the profile payload are saveable/
// verifiable (backend hasattr guard). jsonable_encoder(profile) includes every
// column even when null, so a keyless measurable's key is simply absent.
export function measurableFieldKeys(groups, profile) {
  const p = profile || {};
  const catalogKeys = (groups || [])
    .flatMap(g => g.measurables || [])
    .map(m => m.key)
    .filter(k => Object.prototype.hasOwnProperty.call(p, k));
  const gearKeys = GEAR_FIELD_KEYS.filter(k => Object.prototype.hasOwnProperty.call(p, k));
  return [...catalogKeys, ...gearKeys];
}

export function verificationCounts(profile, fieldKeys) {
  const p = profile || {};
  let verified = 0, unverified = 0, empty = 0;
  for (const key of fieldKeys) {
    if (!hasValue(p[key])) { empty += 1; continue; }
    if (p[`${key}_verified`]) verified += 1; else unverified += 1;
  }
  return { verified, unverified, empty };
}

export function latestVerifierFor(logs, statKey) {
  const verified = (logs || []).filter(l => l.stat_name === statKey && l.action === 'verified');
  if (verified.length === 0) return null;
  const newest = verified.reduce((a, b) =>
    (String(b.created_at || '') > String(a.created_at || '') ? b : a));
  const name = newest.verified_by_2 ? `${newest.verified_by} + ${newest.verified_by_2}` : (newest.verified_by || '');
  return { name, date: newest.created_at, camp: newest.camp_name || null };
}

export function formatSavedAgo(lastSavedAtMs, nowMs) {
  if (lastSavedAtMs == null) return '';
  const secs = Math.max(0, Math.floor((nowMs - lastSavedAtMs) / 1000));
  if (secs < 5) return 'just now';
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  return `${Math.floor(mins / 60)}h ago`;
}

export function statDisplayLabel(groups, key) {
  const m = (groups || []).flatMap(g => g.measurables || []).find(x => x.key === key);
  return (m && m.label) || humanize(key);
}
